import {
    createSelector,
    createStructuredSelector,
} from 'reselect';
import { initialState } from './reducer';
import { RootState } from '../../interface';
import { Namespace } from '../../enum';

const selectState = (state: RootState) => state[Namespace.App] || initialState;

export const selectAppState = createSelector(selectState, state => state);
export const selectLoading = createSelector(selectState, state => Object.keys(state.loadingStatus).length > 0);
export const selectError = createSelector(selectState, state => state.error);
export const selectSelectedTariffId = createSelector(selectState, state => state.selectedTariffId);
export const selectTariffs = createSelector(selectState, state => state.tariffs);
export const selectCustomer = createSelector(selectState, state => state.customer);
export const selectSelectedTariff = createSelector(selectState, state => state.tariffs[state.selectedTariffId]);
export const selectLoggedInStatus = createSelector(selectState, state => Boolean(state.customer));

export const mapStateToProps = createStructuredSelector({
    selectedTariffId: selectSelectedTariffId,
    selectedTariff: selectSelectedTariff,
    tariffs: selectTariffs,
    isLoading: selectLoading,
    isLoggedIn: selectLoggedInStatus,
    error: selectError,
    customer: selectCustomer,
});

/**
 * State props by selectors
 */
export type State = ReturnType<typeof mapStateToProps>;
